/*
 *
 * ManageUserModal
 *
 * @version 1.0.0
 * @author Christopher Monti
 * @since 15-Jan-2025
 */

import { connect } from 'react-redux'
import { doPopup } from 'Store/actions/popup'
import ManageUserModal from './ManageUserModal'
import * as formikActions from 'Store/actions/formik'
import * as UsersActions from 'Route/Users/modules/UsersActions'
import { getUserId } from 'Store/selectors'

const mapDispatchToProps = (dispatch) => ({
  closePopup: () => dispatch(doPopup('')),
  submitForm: (payload) => {
    dispatch(formikActions.doSaveForm(payload))
    dispatch(UsersActions.doCreateOrUpdateUser())
  }
})

const mapStateToProps = (state) => ({
  userId: getUserId(state),
  data: state?.popup?.popupData || {},
  isLoading: state.loading?.local_createOrUpdateUser || false
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(ManageUserModal)
